import { updateCollection } from '@wix/ambassador-portfolio-collections-v1-collection/http';
import { chunk as getChunks } from 'lodash';
import { fetchPortfolio } from '../new-infra-fetchers/portfolio-collections/fetch-portfolio';
import { buildPortfolioCollectionsBulkUpdatePayload } from './build-payloads/bulk-update-portfolio-collections-alt-text-payload';
const BULK_LIMIT = 100;
const updateCollectionMethod = async (httpClient, errorHandler, request) => {
  const {
    withErrorHandler
  } = errorHandler;
  const {
    data
  } = await withErrorHandler(async () => httpClient.request(updateCollection(request)), {
    errorCodesMap: {}
  });
  return {
    success: !!data
  };
};
export const updatePortfolioCollectionsAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const portfolioCollections = await fetchPortfolio(httpClient, errorHandler, entityIdsList);
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const portfolioCollectionsMap = new Map(portfolioCollections.map(portfolioCollection => [portfolioCollection.id, portfolioCollection]));
    const updatePromises = chunks.map(async chunk => {
      const payload = buildPortfolioCollectionsBulkUpdatePayload(chunk, portfolioCollectionsMap);
      const {
        collections
      } = payload;
      if (collections.length === 0) {
        return {
          failedElements: chunk,
          success: false
        };
      }
      const collectionsPromises = collections.map(request => updateCollectionMethod(httpClient, errorHandler, request));
      const results = await Promise.all(collectionsPromises);
      const success = results.every(result => result.success);
      if (!success) {
        const failedIndexes = (results ?? []).map((_item, index) => index).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      return {
        success
      };
    });
    const results = await Promise.all(updatePromises);
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-portfolio-collections-alt-text.js.map